import { createCachedSelector, path, defaultKeySelector } from '@cbridge-utils/redux';
import { authStoreSelector } from '../auth.selector';

export const isAuthenticatedSelector = createCachedSelector(
  [
    path(authStoreSelector).isAuthenticated(),
  ],
  (isAuthenticated) => {
    return isAuthenticated;
  },
)({
  keySelector: defaultKeySelector,
});
